import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentAccessToken: null,
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthSuccess: (state, action) => {
            state.currentAccessToken = action.payload;
        },
        setAuthReset: (state) => {
            state.currentAccessToken = null;
        },
    }
});

export const { setAuthSuccess, setAuthReset } = authSlice.actions;

export default authSlice.reducer;